import React from 'react';
import * as Style from './style';
import { ReactComponent as AlertCheck } from '../../../img/alert-check.svg';

export default ({ children }) => (
	<Style.Container>
		<AlertCheck width="30px" height="30px" />
		{children}
	</Style.Container>
);
